export const urls = {
  SearchIndex: {
    URL: "https://unnanu.search.windows.net",
    Key: "0EDAB08ED31C3ADE75ABB19A1FF84D86",
  },
  API: "https://prod-recruit-api-v5.unnanu.com/",
  HireAPI: "https://prod-hire-api-v5.unnanu.com/",
  HireOtherAPI: "https://prod-hire-oth-v5.unnanu.com/",
  TalentOtherAPI: "https://prod-talent-oth-v5.unnanu.com/",
  Recruit: "https://app.unnanu.com",
  Socket: "https://prod-realtime-v5.unnanu.com/",
  Links: {
    Terms: "https://talent.unnanu.com/tos",
    Privacy: "https://talent.unnanu.com/privacy",
    FAQ: "https://talent.unnanu.com/support",
    Cookie: "https://talent.unnanu.com/cookie",
    About: "https://talent.unnanu.com/about",
    Hire: "https://hire.unnanu.com",
    Landing: "https://talent.unnanu.com",
  },
  Image: "https://cdn.unnanu.com",
  BaseURL: "https://jobs.unnanu.com",
};



// WEBPACK FOOTER //
// ./services/api/urls.js